<template>
  <validate validations="required" :validated-value="value" @observe="observe">
    <div class="question">
      <div class="r-text-regular question-text">{{ text }}</div>
      <div class="row content-center options">
        <default-radio :value="value" :val="false" label="לא" v-on="$listeners"/>
        <default-radio :value="value" :val="true" label="כן" v-on="$listeners"/>
      </div>
    </div>
  </validate>
</template>

<script>
import Validate from '@/components/helpers/Validate';
import ValidationObserver from '@/mixins/ValidationObserver';
import DefaultRadio from '@/components/styled/DefaultRadio';

export default {
  name: 'TaxQuestion',
  components: { DefaultRadio, Validate },
  mixins: [ValidationObserver],
  props: {
    value: Boolean,
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">

.question {
  .question-text {
    margin-bottom: 14px;
  }

  .options {
    div:first-child {
      margin-right: 55px;
    }
  }
}

</style>
